// import { EntrepreneurAnnounce10FormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurAnnounce10FormComponent";
import { EntrepreneurCh24Announce10FormComponent } from "../../../components/SupportSystem/SupportForm/EntrepreneurCh24Anncounce10FormComponent";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";

export function EntrepreneurCh24Announce10FormContainer () {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <EntrepreneurCh24Announce10FormComponent/>
            <Footer />
        </div>        
    )
    
}